import { render, staticRenderFns } from "./Regalias.vue?vue&type=template&id=0d67d746&scoped=true&"
import script from "./Regalias.vue?vue&type=script&lang=js&"
export * from "./Regalias.vue?vue&type=script&lang=js&"
import style0 from "./Regalias.vue?vue&type=style&index=0&id=0d67d746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67d746",
  null
  
)

export default component.exports